import React, { useRef, useEffect } from 'react';
import { Image, Send, Mic, MicOff } from 'lucide-react';

export const ChatInput = ({ 
    inputText, 
    setInputText, 
    isSearching, 
    onSend, 
    onImageUpload,
    isRecording,
    onToggleRecording 
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
        inputRef.current.style.height = 'auto';
        inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
        }
    }, [inputText]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (inputText.trim()) onSend();
        }
    };

    return (
        <div className="input-container">
            <div className="input-box">
                <textarea
                ref={inputRef}
                className="text-input"
                placeholder="Type your search query..."
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={handleKeyDown}
                rows={1}
                disabled={isSearching}
                />
                <button
                    className={`action-button ${isRecording ? 'recording' : ''}`}
                    onClick={onToggleRecording}
                    disabled={isSearching}
                >
                    {isRecording ? <MicOff size={20} /> : <Mic size={20} />}
                </button>
                <div className="action-buttons">
                    <label className="action-button">
                        <input
                        type="file"
                        accept="image/*"
                        onChange={onImageUpload}
                        style={{ display: 'none' }}
                        disabled={isSearching}
                        />
                        <Image size={20} />
                    </label>
                </div>
                <button 
                    className="send-button" 
                    onClick={onSend}
                    disabled={!inputText.trim() || isSearching}
                    >
                    <Send size={18} />
                </button>
            </div>
        </div>
    );
};